<script lang="ts">
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			quote: string | ISbRichtext;
			asset?: ISbStoryData['content'];
			image?: SbImage;
			author: string;
			logo: SbImage;
		}>['content'];
		colorClasses?: string;
	}

	let { content, colorClasses = 'bg-stone-4 text-brown-1' }: Props = $props();
</script>

<div use:editable={content} class="flex flex-col gap-y-3 rounded-2xl p-5 lg:p-7 {colorClasses}">
	{#if content.asset && content.asset.length > 0}
		<div class="aspect-square overflow-hidden rounded-lg">
			<Blok content={content.asset[0]} />
		</div>
	{:else if content.image?.filename}
		<Image
			src={content.image.filename}
			class="aspect-square rounded-lg object-cover"
			alt={content.image.alt ?? ''}
			title={content.image.title ?? ''}
			width={780}
		/>
	{/if}
	<div class="text-[20px]/[140%]"><SbRichtext text={content.quote} /></div>
	{#if content.logo?.filename}
		<Image
			wrapperClass="mt-2"
			src={content.logo.filename}
			class="h-6 object-cover"
			alt={content.logo.alt ?? ''}
			title={content.logo.title ?? ''}
			width={780}
		/>
	{:else}
		<p class="font-serif text-[16px]/[130%] tracking-[-.32px]">{content.author}</p>
	{/if}
</div>
